import { defu } from "defu";

interface UseBreadCrumbsJsonLD {}
type JsonLDObject = { [key: string]: JsonLDValue };
type JsonLDValue = string | number | JsonLDObject | JsonLDValue[];

export function useBreadCrumbsJsonLD(
  breadCrumbs: Array<{
    name: string;
    path?: string;
  }>,
  additionalData: JsonLDObject = {}
): UseBreadCrumbsJsonLD {
  if (breadCrumbs && breadCrumbs.length) {
    const JsonLd = {
      "@context": "http://schema.org/",
      "@type": "BreadcrumbList",
      itemListElement: breadCrumbs.map((breadcrumb, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@id": breadcrumb.path,
          name: breadcrumb.name,
        },
      })),
    };

    useHead(() => {
      return {
        script: [
          {
            type: "application/ld+json",
            children: JSON.stringify(defu(JsonLd, additionalData)),
          },
        ],
      };
    });
  }
  return {};
}
